import {
  FormControlLabel,
  SelectChangeEvent,
  Stack,
  Switch,
  TextField,
} from '@mui/material';
import { FormsErrorDataType } from 'containers/dashboard/Forms/FormListingType';
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  allowRedirection: boolean;
  redirectUrl: string;
  onChangeMode: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeElement: (
    e:
      | React.ChangeEvent<
          HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
        >
      | SelectChangeEvent
  ) => void;
  stateError: FormsErrorDataType;
};

const RedirectionSettings: FunctionComponent<Props> = ({
  allowRedirection,
  redirectUrl,
  onChangeMode,
  stateError,
  onChangeElement,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction='column' spacing='30px'>
      <FormControlLabel
        control={
          <Switch
            name='allowRedirection'
            checked={allowRedirection}
            onChange={onChangeMode}
          />
        }
        label={t('allow_redirection')}
      />
      {allowRedirection ? (
        <>
          <TextField
            id='outlined-basic'
            name='redirectUrl'
            label={t('redirect_url')}
            variant='outlined'
            type='string'
            value={redirectUrl}
            onChange={onChangeElement}
            error={stateError.redirectUrl.length ? true : false}
            helperText={stateError.redirectUrl}
          />
        </>
      ) : null}
    </Stack>
  );
};

export default React.memo(RedirectionSettings);
